import { type FC, type PropsWithChildren, type ReactNode } from 'react'

import { Card, CardContent, Heading } from 'base-ui'

type StoryblokBmiCalculatorCardProps = PropsWithChildren<{
  title: ReactNode
}>

export const StoryblokBmiCalculatorCard: FC<
  StoryblokBmiCalculatorCardProps
> = ({ children, title }) => (
  <Card className="bg-light-primary-low">
    <CardContent className="flex h-full flex-col">
      <Heading className="mb-6" level={3} size="l">
        {title}
      </Heading>
      {children}
    </CardContent>
  </Card>
)
